import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import heroPhoto1200 from '#src/app/pages/about/impact/shared/assets/ups-petition-1200w.webp';
import heroPhoto800 from '#src/app/pages/about/impact/shared/assets/ups-petition-800w.webp';

/** Spans the container on desktop; mobile full width. Lets browser pick 1x vs 2x. */
const PHOTO_SIZES = '(max-width: 767px) 100vw, 1200px';

export const Hero: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();

	return (
		<section className="container flex flex-col gap-8 pt-16 pb-16 md:gap-12 md:pt-30 md:pb-32">
			<div className="mx-auto flex max-w-[680px] flex-col gap-4 text-center">
				<Text
					as="h1"
					variant="heading"
					size="x-large"
					fontWeight="bold"
					className="text-balance"
					data-qa="impact-hero-heading"
				>
					<Translate value="corgi.impact_page.hero.heading" />
				</Text>
				<Text as="p" variant="body" size="large" className="text-typography-weak">
					<Translate value="corgi.impact_page.hero.subheading" />
				</Text>
			</div>
			{/* The DS Image has no 21:9 ratio, so the frame owns the ratio and the photo covers it. */}
			<div
				className="bg-background-raised aspect-[4/3] overflow-hidden rounded-2xl md:aspect-[21/9]"
				data-qa="impact-hero-photo"
			>
				<img
					src={heroPhoto800}
					srcSet={`${heroPhoto800} 800w, ${heroPhoto1200} 1200w`}
					sizes={PHOTO_SIZES}
					alt={translate('corgi.impact_page.hero.photo_alt')}
					className="h-full w-full object-cover object-[50%_34%]"
				/>
			</div>
		</section>
	);
};
